var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUniversityConnect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220,322.67s.43,12.43,3.43,20.29,15.86,30.15,19,35.72,4,7.14,4,7.14a116.21,116.21,0,0,0-7,9.58c-2.14,3.57-6,5.43-5.14,6.86s1.86,1.28,6.43.14,6-3.72,9.72-6.72,6.71-3.14,6.85-5.43-4.57-6.57-5.57-9.29-6.71-14.71-10-27.72-6.43-17.14-6.57-18.71,1.28-11.44,1.28-11.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.68,321.38a50.18,50.18,0,0,0,6.57,13.15c5,7.43,24.72,28.29,26.58,31s5.15,14.15,6.43,18.15,5.29,2.43,6.72-2.72-6.57-16.57-8.15-18.86-10-12.57-15.14-25.15-8.15-19.71-8.15-19.71S254.68,319.81,252.68,321.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239,203.78a18.23,18.23,0,0,1-5.28-.71c-3.29-.86-6,0-9.58,4.14s-7.86,15.29-7.86,23.58,5.15,18,5.15,18-5.72,8.15-8,23.58,1.14,52.72,1.14,52.72,15.15,3.58,30.72,1a118.42,118.42,0,0,0,28-8.43s.57-16.71-6.58-38.72a362.47,362.47,0,0,0-12.86-34.58s3.72-14.72,3.86-24.72-3.43-13.29-6.14-14.57S239,203.78,239,203.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.82,193.78a36.89,36.89,0,0,1-2.14,9c-1.57,3.57-2.57,2.72-4,9.15s3.43,15,8.86,11.43,8.86-10.86,8.57-13.58-1.57-3.28-1.57-7a30.9,30.9,0,0,1,1-7.29S241.11,196.06,237.82,193.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.11,157.48s-8.15,23.58-8.72,29.73a11.45,11.45,0,0,0,11.15,12.43c7,.14,12.57-8,12.57-8s2.86,2.29,6.57-.28S276,166.06,276,166.06s-4.43-7.58-15.72-9.72S242.11,157.48,242.11,157.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313,168.34s1.43,13.72,4.29,20.15,6.8,20.19,6.14,28c-.47,5.67-2.43,6.43-4,6.43s-6.61-3.45-9.86-9.72c-6.07-11.69-4.28-20.29-2.43-27.15S313,168.34,313,168.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.2,212.1c-7.12-27.29-19-52.73-31.35-70.18C344.06,100,274.81,81.52,227,99.09c-40.77,15-55,60.24-90.65,81.92-32.77,19.94-62.5,36.2-74,74.21-24.21,80.31,71.51,144.33,143,124,22.57-6.42,41.66-19.95,65.74-20,48.84-.17,66.05,6.53,105.57-19.86C415.65,313.29,417.67,259.88,405.2,212.1Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,212.1c-7.12-27.29-19-52.73-31.35-70.18C344.06,100,274.81,81.52,227,99.09c-40.77,15-55,60.24-90.65,81.92-32.77,19.94-62.5,36.2-74,74.21-24.21,80.31,71.51,144.33,143,124,22.57-6.42,41.66-19.95,65.74-20,48.84-.17,66.05,6.53,105.57-19.86C415.65,313.29,417.67,259.88,405.2,212.1Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.49,387.52c-3.94,0-3.94,4.38-7.89,4.38s-3.94-4.38-7.88-4.38-4,4.38-7.89,4.38-3.95-4.38-7.89-4.38-3.94,4.38-7.89,4.38-3.94-4.38-7.89-4.38-3.94,4.38-7.88,4.38-3.95-4.38-7.89-4.38-3.94,4.38-7.89,4.38-3.94-4.38-7.88-4.38-3.95,4.38-7.89,4.38-3.94-4.38-7.88-4.38-4,4.38-7.89,4.38-3.94-4.38-7.88-4.38-3.94,4.38-7.89,4.38-3.94-4.38-7.88-4.38-3.94,4.38-7.88,4.38-3.95-4.38-7.89-4.38-3.94,4.38-7.88,4.38-3.94-4.38-7.88-4.38-3.94,4.38-7.89,4.38-3.94-4.38-7.88-4.38-3.94,4.38-7.89,4.38-3.94-4.38-7.88-4.38-4,4.38-7.89,4.38-3.94-4.38-7.88-4.38-3.95,4.38-7.89,4.38-3.94-4.38-7.88-4.38-3.95,4.38-7.89,4.38-3.94-4.38-7.88-4.38S197,391.9,193,391.9s-3.94-4.38-7.88-4.38-3.94,4.38-7.88,4.38-3.95-4.38-7.89-4.38-3.94,4.38-7.88,4.38-3.95-4.38-7.89-4.38-3.94,4.38-7.88,4.38-3.94-4.38-7.89-4.38-3.94,4.38-7.88,4.38-3.94-4.38-7.88-4.38-3.94,4.38-7.89,4.38-3.94-4.38-7.88-4.38-3.94,4.38-7.88,4.38-3.94-4.38-7.89-4.38-3.94,4.38-7.88,4.38-3.94-4.38-7.88-4.38-3.94,4.38-7.89,4.38S63,387.52,59,387.52s-3.94,4.38-7.88,4.38l-.38,0V406.5H444.28V391.75C441.41,391,441,387.52,437.49,387.52Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.4,
    y1: 403.71,
    x2: 137.4,
    y2: 363.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.6553300000000002px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.75,
    y1: 365.17,
    x2: 137.4,
    y2: 378.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.6553300000000002px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.4,
    y1: 392.52,
    x2: 158.54,
    y2: 364.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.6553300000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.31,366.37V353.49a54.22,54.22,0,0,0-54.22-54.23h0a54.22,54.22,0,0,0-54.22,54.23v12.88Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.31,366.37V353.49a54.22,54.22,0,0,0-54.22-54.23h0a54.22,54.22,0,0,0-54.22,54.23v12.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,366.37H194.31V353.49a54,54,0,0,0-5-22.7l-.3.28a7.24,7.24,0,0,0-13.1-.1,4,4,0,0,0-2.39-.79,3.86,3.86,0,0,0-3.77,2.76,4,4,0,0,0-3.3-1.71,4,4,0,0,0-2.49.86,4,4,0,0,0-7.49-.51,4.05,4.05,0,0,0-2.29-.7,4,4,0,0,0-2.68,1,7.23,7.23,0,0,0-13-.44,4,4,0,0,0-3.24-1.62,3.86,3.86,0,0,0-3.78,2.78,3.87,3.87,0,0,0-3.66-2.43,4,4,0,0,0-3,1.38,4,4,0,0,0-7.4.23,7.33,7.33,0,0,0-11,.75,3.83,3.83,0,0,0-3.84-3.06,3.89,3.89,0,0,0-3.65,2.4A4,4,0,0,0,96,330.7a3.87,3.87,0,0,0-1.13.18,6.82,6.82,0,0,0-2.62-2.94,53.94,53.94,0,0,0-6.39,25.55Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.31,353.49a54.31,54.31,0,0,0-1.05-10.67,10.73,10.73,0,0,0-1.51-.11c-3.6,0-6.67,1.7-8,4.11a5.65,5.65,0,0,0-2.92-.79,4.7,4.7,0,0,0-4.6,2.76,5.17,5.17,0,0,0-4-1.71,5.6,5.6,0,0,0-3,.86c-.43-1.68-2.36-3-4.67-3a4.83,4.83,0,0,0-4.47,2.45,5.7,5.7,0,0,0-2.78-.7,5.57,5.57,0,0,0-3.27,1c-1.22-2.53-4.36-4.33-8.07-4.33-3.48,0-6.48,1.6-7.83,3.89a5.26,5.26,0,0,0-3.95-1.62,4.7,4.7,0,0,0-4.61,2.78,4.84,4.84,0,0,0-4.46-2.43,5.4,5.4,0,0,0-3.7,1.38A4.84,4.84,0,0,0,117,345a4.73,4.73,0,0,0-4.56,2.67,9.85,9.85,0,0,0-6.32-2.14,9.52,9.52,0,0,0-7.1,2.88c-.38-1.73-2.32-3.06-4.68-3.06a4.87,4.87,0,0,0-4.46,2.41,5.42,5.42,0,0,0-3.48-1.19h0a54.63,54.63,0,0,0-.44,6.93v12.88H194.31Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.04,
    y1: 403.71,
    x2: 357.04,
    y2: 363.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.6553300000000002px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.39,
    y1: 365.17,
    x2: 357.04,
    y2: 378.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.6553300000000002px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.04,
    y1: 392.52,
    x2: 378.18,
    y2: 364.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.6553300000000002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,366.37V353.49a54.22,54.22,0,0,0-54.22-54.23h0a54.22,54.22,0,0,0-54.22,54.23v12.88Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,366.37V353.49a54.22,54.22,0,0,0-54.22-54.23h0a54.22,54.22,0,0,0-54.22,54.23v12.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.51,366.37H414V353.49a54,54,0,0,0-5-22.7l-.3.28a7.24,7.24,0,0,0-13.1-.1,4,4,0,0,0-2.39-.79,3.86,3.86,0,0,0-3.77,2.76,4,4,0,0,0-3.3-1.71,4,4,0,0,0-2.49.86,4,4,0,0,0-7.49-.51,4.05,4.05,0,0,0-2.29-.7,4,4,0,0,0-2.68,1,7.23,7.23,0,0,0-13-.44,4,4,0,0,0-3.24-1.62,3.86,3.86,0,0,0-3.78,2.78,3.87,3.87,0,0,0-3.66-2.43,4,4,0,0,0-3,1.38,4,4,0,0,0-7.4.23,7.33,7.33,0,0,0-11,.75,3.83,3.83,0,0,0-3.84-3.06,3.89,3.89,0,0,0-3.65,2.4,4,4,0,0,0-2.86-1.18,3.87,3.87,0,0,0-1.13.18,6.78,6.78,0,0,0-2.63-2.94,54,54,0,0,0-6.38,25.55Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,353.49a54.31,54.31,0,0,0-1.05-10.67,10.73,10.73,0,0,0-1.51-.11c-3.6,0-6.67,1.7-8,4.11a5.65,5.65,0,0,0-2.92-.79,4.7,4.7,0,0,0-4.6,2.76,5.17,5.17,0,0,0-4-1.71,5.6,5.6,0,0,0-3,.86c-.43-1.68-2.36-3-4.67-3a4.83,4.83,0,0,0-4.47,2.45,5.7,5.7,0,0,0-2.78-.7,5.57,5.57,0,0,0-3.27,1c-1.22-2.53-4.36-4.33-8.07-4.33-3.48,0-6.48,1.6-7.83,3.89a5.26,5.26,0,0,0-3.95-1.62,4.7,4.7,0,0,0-4.61,2.78,4.84,4.84,0,0,0-4.46-2.43,5.4,5.4,0,0,0-3.7,1.38,4.84,4.84,0,0,0-4.46-2.43,4.73,4.73,0,0,0-4.56,2.67,9.85,9.85,0,0,0-6.32-2.14,9.52,9.52,0,0,0-7.1,2.88c-.38-1.73-2.32-3.06-4.68-3.06a4.87,4.87,0,0,0-4.46,2.41,5.42,5.42,0,0,0-3.48-1.19h0a54.63,54.63,0,0,0-.44,6.93v12.88H414Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.31,126.61c-4-2.16-5.76-.36-7.2-2.16s4-6.49-6.84-11.17c0,0-.72-10.08-15.48-10.44S290,112.92,286,115.44s-5-1.44-9,1.08-2.16,7.57-5.4,8.29-7.56-3.24-11.52-.72-4,4.68-5.77,4.68-5.4-1.44-7.56,0-4.68,3.24-4.68,3.24h91.1S334.27,128.77,330.31,126.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,218.25c-2.74-1.49-4-.24-5-1.49s2.73-4.48-4.73-7.71c0,0-.5-7-10.7-7.21s-7.46,7-10.19,8.7-3.49-1-6.22.75-1.49,5.22-3.73,5.72-5.23-2.24-8-.5-2.74,3.24-4,3.24-3.73-1-5.23,0-3.23,2.24-3.23,2.24H390S390.77,219.75,388,218.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.39,204.15c-1.72-.93-2.5-.15-3.12-.93s1.72-2.82-3-4.85c0,0-.32-4.38-6.73-4.53s-4.69,4.37-6.41,5.47-2.18-.63-3.9.47-.94,3.28-2.35,3.59-3.28-1.4-5-.31-1.72,2-2.5,2-2.35-.62-3.29,0-2,1.41-2,1.41h39.55A2,2,0,0,0,350.39,204.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.88,239c-6.15-3.35-8.94-.56-11.18-3.35s6.15-10.06-10.62-17.33c0,0-1.12-15.66-24-16.21s-16.77,15.65-22.92,19.56-7.83-2.23-14,1.68-3.35,11.74-8.38,12.86-11.74-5-17.89-1.12-6.15,7.27-9,7.27-8.38-2.24-11.74,0-7.27,5-7.27,5H214.36S216,242.36,209.88,239Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,322.67s.43,12.43,3.43,20.29,15.86,30.15,19,35.72,4,7.14,4,7.14a116.21,116.21,0,0,0-7,9.58c-2.14,3.57-6,5.43-5.14,6.86s1.86,1.28,6.43.14,6-3.72,9.72-6.72,6.71-3.14,6.85-5.43-4.57-6.57-5.57-9.29-6.71-14.71-10-27.72-6.43-17.14-6.57-18.71,1.28-11.44,1.28-11.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.23,389.87c-.32-2.35-4.6-6.33-5.55-8.91s-6.71-14.71-10-27.72-6.43-17.14-6.57-18.71,1.28-11.44,1.28-11.44L220,322.67s.15,4.46.92,9.73c.92.14,2,.26,3.29.34a22.37,22.37,0,0,0,8.27-.91s-.92,3.67,2.14,13.16,12.86,32.46,15,36.44C250.75,383.6,254.26,387.11,257.23,389.87Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.23,389.87c-.32-2.35-4.6-6.33-5.55-8.91s-6.71-14.71-10-27.72-6.43-17.14-6.57-18.71,1.28-11.44,1.28-11.44L220,322.67s.15,4.46.92,9.73c.92.14,2,.26,3.29.34a22.37,22.37,0,0,0,8.27-.91s-.92,3.67,2.14,13.16,12.86,32.46,15,36.44C250.75,383.6,254.26,387.11,257.23,389.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220,322.67s.43,12.43,3.43,20.29,15.86,30.15,19,35.72,4,7.14,4,7.14a116.21,116.21,0,0,0-7,9.58c-2.14,3.57-6,5.43-5.14,6.86s1.86,1.28,6.43.14,6-3.72,9.72-6.72,6.71-3.14,6.85-5.43-4.57-6.57-5.57-9.29-6.71-14.71-10-27.72-6.43-17.14-6.57-18.71,1.28-11.44,1.28-11.44Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25,390.25c.08-1.18-1.15-2.9-2.49-4.66l-6.65,5.81s-.72-2-1.57-3.86a2.1,2.1,0,0,0-.76-1,104.17,104.17,0,0,0-6.39,8.81c-2.14,3.57-6,5.43-5.14,6.86s1.86,1.28,6.43.14,6-3.72,9.72-6.72S257.11,392.54,257.25,390.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.68,321.38a50.18,50.18,0,0,0,6.57,13.15c5,7.43,24.72,28.29,26.58,31s5.15,14.15,6.43,18.15,5.29,2.43,6.72-2.72-6.57-16.57-8.15-18.86-10-12.57-15.14-25.15-8.15-19.71-8.15-19.71S254.68,319.81,252.68,321.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.83,362.1c-1.57-2.28-10-12.57-15.14-25.15s-8.15-19.71-8.15-19.71-12.86,2.57-14.86,4.14a43.87,43.87,0,0,0,3.6,8.26,32.35,32.35,0,0,0,9.84-2.41s7.35,16.54,12.56,23.89c2.76,3.9,8.73,9.19,13.72,13.29C291.71,363.37,291.14,362.55,290.83,362.1Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.83,362.1c-1.57-2.28-10-12.57-15.14-25.15s-8.15-19.71-8.15-19.71-12.86,2.57-14.86,4.14a43.87,43.87,0,0,0,3.6,8.26,32.35,32.35,0,0,0,9.84-2.41s7.35,16.54,12.56,23.89c2.76,3.9,8.73,9.19,13.72,13.29C291.71,363.37,291.14,362.55,290.83,362.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.68,321.38a50.18,50.18,0,0,0,6.57,13.15c5,7.43,24.72,28.29,26.58,31s5.15,14.15,6.43,18.15,5.29,2.43,6.72-2.72-6.57-16.57-8.15-18.86-10-12.57-15.14-25.15-8.15-19.71-8.15-19.71S254.68,319.81,252.68,321.38Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.26,383.68c1.29,4,5.29,2.43,6.72-2.72s-6.57-16.57-8.15-18.86l-.42-.59c.7,1.87,1.42,3.74,1.42,3.74a3.32,3.32,0,0,0-3.43-.86c-2.28.57-1.14,4-1.14,4v.09C289.06,373,291.26,380.57,292.26,383.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,292.29s2.22-5.06,10.48-6.54,18.68,7,22.92,8.51,6.6-25.79,2.37-51.43-10.17-27.53-19.07-15.67S196.86,285.09,196,292.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,218.5c-12.14-23.44-21.15-26.58-28.43-32s-7.72-5.57-13.86-10S250.4,166.91,246,165.77a7.64,7.64,0,0,0-7.15,1.61s-6.29,2-14,9.82-1.15,14.43-1.15,14.43-2,8.72,8.15,18.72,16,39.16,50,40.87S323.13,241.93,311,218.5Zm-84.3-33.58c-2.4,3.35-2.42,4.9-2.17,5.56a3.77,3.77,0,0,0,.31.44.84.84,0,0,1-.31-.44,7.77,7.77,0,0,1-.69-6c1-4.14,8.86-8.14,8.86-8.14S230.25,179.92,226.68,184.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,203.78a18.23,18.23,0,0,1-5.28-.71c-3.29-.86-6,0-9.58,4.14s-7.86,15.29-7.86,23.58,5.15,18,5.15,18-5.72,8.15-8,23.58,1.14,52.72,1.14,52.72,15.15,3.58,30.72,1a118.42,118.42,0,0,0,28-8.43s.57-16.71-6.58-38.72a362.47,362.47,0,0,0-12.86-34.58s3.72-14.72,3.86-24.72-3.43-13.29-6.14-14.57S239,203.78,239,203.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239,203.78a18.23,18.23,0,0,1-5.28-.71c-3.29-.86-6,0-9.58,4.14s-7.86,15.29-7.86,23.58,5.15,18,5.15,18-5.72,8.15-8,23.58,1.14,52.72,1.14,52.72,15.15,3.58,30.72,1a118.42,118.42,0,0,0,28-8.43s.57-16.71-6.58-38.72a362.47,362.47,0,0,0-12.86-34.58s3.72-14.72,3.86-24.72-3.43-13.29-6.14-14.57S239,203.78,239,203.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239,203.78a18.23,18.23,0,0,1-5.28-.71c-3.29-.86-6,0-9.58,4.14s-7.86,15.29-7.86,23.58,5.15,18,5.15,18-5.72,8.15-8,23.58,1.14,52.72,1.14,52.72,15.15,3.58,30.72,1a118.42,118.42,0,0,0,28-8.43s.57-16.71-6.58-38.72a362.47,362.47,0,0,0-12.86-34.58s3.72-14.72,3.86-24.72-3.43-13.29-6.14-14.57S239,203.78,239,203.78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.11,235.07s2.28,7,8.43,10.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,193.78a36.89,36.89,0,0,1-2.14,9c-1.57,3.57-2.57,2.72-4,9.15s3.43,15,8.86,11.43,8.86-10.86,8.57-13.58-1.57-3.28-1.57-7a30.9,30.9,0,0,1,1-7.29S241.11,196.06,237.82,193.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.82,193.78a37.58,37.58,0,0,1-2.08,8.85c1.78,1.94,5.41,4.11,11.88,1.61a12.58,12.58,0,0,1-.08-1.46,30.79,30.79,0,0,1,1-7.29S241.11,196.06,237.82,193.78Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,193.78a37.58,37.58,0,0,1-2.08,8.85c1.78,1.94,5.41,4.11,11.88,1.61a12.58,12.58,0,0,1-.08-1.46,30.79,30.79,0,0,1,1-7.29S241.11,196.06,237.82,193.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,193.78a36.89,36.89,0,0,1-2.14,9c-1.57,3.57-2.57,2.72-4,9.15s3.43,15,8.86,11.43,8.86-10.86,8.57-13.58-1.57-3.28-1.57-7a30.9,30.9,0,0,1,1-7.29S241.11,196.06,237.82,193.78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11,157.48s-8.15,23.58-8.72,29.73a11.45,11.45,0,0,0,11.15,12.43c7,.14,12.57-8,12.57-8s2.86,2.29,6.57-.28S276,166.06,276,166.06s-4.43-7.58-15.72-9.72S242.11,157.48,242.11,157.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.25,156.34a41.14,41.14,0,0,0-6-.69l-3.39,12s4.89,14.15,4.59,18.13-3.68,11.63-12.56,11.63a16.85,16.85,0,0,1-6.15-1.11,11.22,11.22,0,0,0,7.84,3.36c7,.14,12.57-8,12.57-8s2.86,2.29,6.57-.28S276,166.06,276,166.06,271.54,158.48,260.25,156.34Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,156.34a41.14,41.14,0,0,0-6-.69l-3.39,12s4.89,14.15,4.59,18.13-3.68,11.63-12.56,11.63a16.85,16.85,0,0,1-6.15-1.11,11.22,11.22,0,0,0,7.84,3.36c7,.14,12.57-8,12.57-8s2.86,2.29,6.57-.28S276,166.06,276,166.06,271.54,158.48,260.25,156.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.11,157.48s-8.15,23.58-8.72,29.73a11.45,11.45,0,0,0,11.15,12.43c7,.14,12.57-8,12.57-8s2.86,2.29,6.57-.28S276,166.06,276,166.06s-4.43-7.58-15.72-9.72S242.11,157.48,242.11,157.48Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.11,175.06a5.83,5.83,0,0,1-2.72,3.43c-2.14,1.14-4,1-3.28,2.14a4.64,4.64,0,0,0,2.57,1.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25,184.63a7.44,7.44,0,0,0,4,1.43,7.64,7.64,0,0,0,4.86-1.28s-4.43,5.14-6.72,5.14S241.25,184.63,241.25,184.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.68,176.35s2.57-2.72,4.57.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.54,175.06a2.14,2.14,0,0,1,3.57.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,172.06a4,4,0,0,1,3.86-2.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68,169.92s1.57-.58,3,2.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.82,167.63s4,8.57,7.72,17.57S277.4,205.35,280,206.07s10.86-13.15,10.86-13.15-14.5-10.24-19.82-14.69S259.83,169.06,250.82,167.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,165.06l-16.28-10.43s20-8.29,25-12.86c0,0,32.29,21,44.15,22.43,0,0-18.14,7-26.43,9Z",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,166.06s-4.43-7.58-15.72-9.72-18.14,1.14-18.14,1.14-1.52,4.4-3.29,9.9a26.18,26.18,0,0,1,15,1c7,2.38,13.33,6.83,17.19,9.89C273.71,172.05,276,166.06,276,166.06Z",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.68,154.63s-1.15,8.28-7.15,7.43-3.86-8.86,3-15.29,3.72-14-.86-15.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.82,131.76s-1.86-1.71-6.29-2.28-11.57-2-11.29-1.43.14,2,.43,3,.86,2.29,2.43,2.29,12.43-.29,13.72-.29S221.82,131.76,221.82,131.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,168.34s1.43,13.72,4.29,20.15,6.8,20.19,6.14,28c-.47,5.67-2.43,6.43-4,6.43s-6.61-3.45-9.86-9.72c-6.07-11.69-4.28-20.29-2.43-27.15S313,168.34,313,168.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313,168.34s1.43,13.72,4.29,20.15,6.64,19.72,6.14,28c-.34,5.68-2.43,6.43-4,6.43s-4.43,2.28-9.86-9.72-4.28-20.29-2.43-27.15S313,168.34,313,168.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313,168.34s1.43,13.72,4.29,20.15,6.8,20.19,6.14,28c-.47,5.67-2.43,6.43-4,6.43s-6.61-3.45-9.86-9.72c-6.07-11.69-4.28-20.29-2.43-27.15S313,168.34,313,168.34Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.12,170.06s9.15-12.29,10.86-15.72,4.43-7,6.43-7.29,7.15,4,7.43,6.72-2.85,6-5.43,7.14a8.8,8.8,0,0,1-5.28.43s-7.43,13.43-11.58,19.72-6.57,9.15-7.43,9.86-3-2.71-1.71-7.43S313.12,170.06,313.12,170.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.23,148.53s-3,4.5-2.68,5.35,1.34,2,1.95,1.22,3-4.14,2.92-5.48S336.32,147.92,335.23,148.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.34,150.78s-2.67,4-2.35,4.71,1.17,1.71,1.71,1.07,2.67-3.64,2.56-4.82S338.3,150.25,337.34,150.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,145.62s-3.58,5.29-3.15,6.29,1.57,2.29,2.29,1.43,3.57-4.86,3.43-6.43S334.27,144.91,333,145.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.27,143.34s-3.57,5.28-3.14,6.29,1.57,2.28,2.28,1.42,3.58-4.85,3.43-6.43S331.56,142.62,330.27,143.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.84,156.06s3.86-9.86,4.72-9.86,5.57,2.71,5.85,4,0,1.43-.85,1.57-3.57-1.43-3.57-1.43,1.28,3-.58,5.14-3.43,2.29-3.43,2.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8,156.37s-7.52-13.34-8.79-17-3.51-7.5-5.46-8-7.59,3.07-8.22,5.73,2.08,6.31,4.49,7.77A8.85,8.85,0,0,0,183,146s5.68,14.26,9,21,5.36,9.9,6.12,10.72,3.32-2.32,2.64-7.16S195.8,156.37,195.8,156.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.59,132.23s2.45,4.85,2,5.65-1.58,1.76-2.09,1-2.49-4.49-2.2-5.8S175.58,131.49,176.59,132.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.21,134.2s2.15,4.26,1.74,5-1.38,1.55-1.83.85-2.2-3.95-1.94-5.1S173.32,133.55,174.21,134.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.18,129.63s2.87,5.69,2.32,6.63-1.84,2.07-2.45,1.13-2.93-5.27-2.59-6.81S178,128.76,179.18,129.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.16,127.7s2.88,5.7,2.32,6.64-1.84,2.07-2.44,1.13-2.94-5.27-2.6-6.81S181,126.83,182.16,127.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.93,141.13s-2.58-10.27-3.43-10.37-5.87,2-6.32,3.23-.18,1.41.66,1.66,3.72-1,3.72-1-1.65,2.81-.08,5.17,3.11,2.7,3.11,2.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,203.78s-2.43-4.57-5.43-3.86-6.29,10.72-6.29,24,7.72,39.58,14,56,7.86,40.3,7.29,55.16-3.14,16.86-2.43,17.57,3.43.86,18.44-5.71,14.71-13.58,14.71-13.58l-2.57-10s5.29-1.86,14.58-1.71,18.14-5.43,18.43-13.15-10-17-14.29-20.58,6.36-11.36-15.72-25.29c-11.8-7.44-18-20.15-20.72-25.58s-2.28-8.57.57-11,14.87-6.86,22.72-6.43,19.15,3.29,19.15,3.29-9.29-4.57-9.72-22.58a127,127,0,0,1,3.29-32s-3.71,3.43-10.57,9.72-6.43,7.86-11.86,7.86-10.29,1.14-12,5.57-3.71,7-7.85,6.86-5.43-2.86-9.44.14S257,203.78,257,203.78Z",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,203.78s-5.43,11.86-4,30,10,39.29,21.72,52.87,19.14,35.15,19.14,35.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.11,241.07s3.86,16.15,14.72,29.58,28.29,16.86,28.29,16.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.11,222.5s-1.71,5.29,2.29,13.86,5,9.72,5,9.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,226.21a27.12,27.12,0,0,0-6.14,8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.26,219.64c1.47.08,3.06.25,4.67.46a8.52,8.52,0,0,1-5.11-6.23c-1.46-5.57,3.06-21,5-27.56a54.58,54.58,0,0,0,2.12-12.4l-4.2,3.86a50.94,50.94,0,0,1-1.58,7.47c-3.51,11.95-6.54,23.81-5,29.6a14.46,14.46,0,0,0,2.19,4.8C299,219.61,299.64,219.61,300.26,219.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,204.07s1.43-4.58-1.43-6.86-5.85,1.14-5.85,1.14a14.94,14.94,0,0,1-5.86-6.57c-2.43-4.86.43-8-5.15-15s-9.14-9.14-7.71-15.71,7.43-11.43,3.14-14.29-14.72-2.72-22.43,6-6.86,13.57-9.86,16.86-9.58,7.43-5.58,13.86,10.72,8.86,17,9.86,15.29,8.57,17.29,17-.57,18.29-4.43,26.3-14.72,18.57-18,34.86,7,24.72,8.86,31.15,4.43,22.86,1.43,32.15A23.55,23.55,0,0,1,182.52,348s4.15,6.14,14.43,7.28,12.29,0,13.15-4.43,1.86-19.29-1.57-35.15-10.86-23-6-37,9.43-30.87,14.71-43.16S232,204.07,232,204.07Z",
    style: {
      fill: "#31859B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24,197.06s2.86.29,1.29,7.58-7,20.43-7,20.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67,301.37s-3-5-1.43-17.57S198,254.94,203,240.5s7.28-19.86,7.28-19.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.39,199.64s0,2.71-6.72,16.57-10.14,25.29-10.28,33.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.85,175.78c1.2-1,2.44-2,3.56-3.05,3.21-3,4.49-6.49,5.62-9.52,1-2.63,1.82-4.91,3.77-6.33,2.34-1.73,6.93.1,9.91,1.72a31.75,31.75,0,0,1,1.62-3.47c-3.54-1.92-9.64-4.38-13.79-1.32-2.86,2.1-4,5.13-5.09,8.07-1,2.77-2.1,5.64-4.67,8.08-1,1-2.15,1.89-3.34,2.87-3.53,2.89-7.64,6.27-9.47,11.75a18.18,18.18,0,0,0,3.09,3.32C176,182.23,179.84,179.07,183.85,175.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ground--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.76,
    y: 402.31,
    width: 393.52,
    height: 6.39,
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityConnect);
export default __webpack_public_path__ + "static/media/university-connect.7c397fa9ac57c2010eff691ef2de10d1.svg";
export { ForwardRef as ReactComponent };